import { defaultFont } from "assets/jss/material-kit-pro-react.js";

const headerLinksStyle = (theme) => ({
  list: {
    ...defaultFont,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: "6px",
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  listItem: {
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 24px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "12px",
        backgroundColor: "rgba(255,255,255,0.08)",
      },
    },
  },
  listItemText: {
    padding: "0 !important",
  },
  navLink: {
    color: "inherit",
    position: "relative",
    padding: "0.85rem 1rem",
    fontWeight: 600,
    fontSize: "11px",
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    borderRadius: "999px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    transition: "background 180ms ease, color 180ms ease, transform 180ms ease",
    "&:hover,&:focus": {
      color: "#fff8ee",
      background: "rgba(255, 255, 255, 0.08)",
      transform: "translateY(-1px)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 24px)",
      marginLeft: "12px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      justifyContent: "flex-start",
      borderRadius: "16px",
      "& > span:first-child": {
        justifyContent: "flex-start",
      },
    },
  },
  socialIcons: {
    position: "relative",
    fontSize: "18px !important",
    marginRight: "0",
  },
  tooltip: {
    fontSize: "12px",
  },
  socialButton: {
    minWidth: "44px",
    width: "44px",
    height: "44px",
    padding: 0,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.16)",
    background: "rgba(255,255,255,0.06)",
    transition: "transform 180ms ease, background 180ms ease, border-color 180ms ease",
    "&:hover,&:focus": {
      transform: "translateY(-1px)",
      background: "rgba(212,179,127,0.14)",
      borderColor: "rgba(212,179,127,0.32)",
    },
  },
  ctaButton: {
    marginLeft: "8px",
    minHeight: "44px",
    padding: "0 18px",
    borderRadius: "999px",
    border: "1px solid rgba(212,179,127,0.34)",
    background: "linear-gradient(135deg, rgba(212,179,127,0.22) 0%, rgba(212,179,127,0.12) 100%)",
    color: "#f6ecdd",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    "&:hover,&:focus": {
      background: "linear-gradient(135deg, rgba(212,179,127,0.28) 0%, rgba(212,179,127,0.18) 100%)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 24px)",
      marginLeft: "12px",
      marginBottom: "8px",
      marginTop: "14px",
      justifyContent: "center",
    },
  },
});

export default headerLinksStyle;
